/**
 * Centralised API URL configuration. All URLs in the app should be derived
 * from these constants/helpers so swapping environments is a single edit.
 *
 * Mirrors the routes documented in the Fortify Phase 1 Postman collection.
 */

export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(
  /\/+$/,
  ""
);

export const AUTH_STORAGE_KEY =
  process.env.REACT_APP_AUTH_STORAGE_KEY || "token";

export const REFRESH_TOKEN_STORAGE_KEY =
  process.env.REACT_APP_REFRESH_TOKEN_STORAGE_KEY || "refreshToken";

/** Endpoint catalogue. Strings are paths relative to `API_BASE_URL`; functions
 *  return the same when an id/param is needed. Pair with `lib/api`'s `api.*`
 *  helpers, e.g. `api.get(API_ENDPOINTS.projectDetail(id))`. */
export const API_ENDPOINTS = {
  signup: "/api/auth/signup",
  verifyEmail: "/api/auth/verify-email",
  resendVerification: "/api/auth/resend-verification",
  forgotPassword: "/api/auth/forgot-password",
  resetPassword: "/api/auth/reset-password",
  login: "/api/auth/login",
  logout: "/api/auth/logout",
  me: "/api/auth/me",
  profile: "/api/auth/profile",
  changePassword: "/api/auth/change-password",
  industries: "/api/industries",
  countries: "/api/countries",

  projects: "/api/projects",
  projectDetail: (id) => `/api/projects/${id}`,

  myInvestments: "/api/investments/me",
  investmentCancellationRequest: (investmentId) =>
    `/api/investments/${investmentId}/cancellation-request`,
  investmentCheckout: (projectId) => `/api/investments/${projectId}/checkout`,
  investmentSyncSession: "/api/investments/sync-session",
  investmentsDashboard: "/api/investments/dashboard",

  uploadFile: "/api/uploads/upload-file",

  contact: "/api/contact",

  health: "/health",
  stripeWebhook: "/api/webhooks/stripe",
};
